function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { useQuery } from '@apollo/client';
import SelectDropdown from './';
import { chainedDataIndexExtractor } from '../../../common/utils/chainedDataIndex';
import { useGraphIsLoading } from '../../GraphIndicator';
const Graph = /*#__PURE__*/forwardRef(({
  gql,
  queryKey,
  forwardToField,
  labelKey,
  valueKey,
  manageOptions,
  loadingMessage,
  variables,
  fetchPolicy,
  ...props
}, ref) => {
  const request = useQuery(gql, {
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
    variables
  });
  const options = useMemo(() => request.data && (request.data[queryKey]?.nodes || request.data[queryKey]?.items)?.map((each, index) => {
    if (typeof manageOptions === 'function') {
      return manageOptions(each, index);
    }

    return {
      label: chainedDataIndexExtractor(labelKey, each),
      value: chainedDataIndexExtractor(valueKey, each)
    };
  }) || [], [request.data]);
  const facade = useRef(null);
  useImperativeHandle(forwardToField ? facade : ref, () => {
    const data = request.data && (request.data[queryKey]?.nodes || request.data[queryKey]?.items);
    return {
      refetch: request.refetch,
      options,
      optionsByValue: options.reduce((result, option) => {
        result[option[valueKey]] = option;
        return result;
      }, {}),
      data,
      dataByValue: data?.reduce((result, option) => {
        result[option[valueKey]] = option;
        return result;
      }, {})
    };
  }, [options]);
  useGraphIsLoading(props.name, request.loading);
  return /*#__PURE__*/React.createElement(SelectDropdown, _extends({
    ref: forwardToField ? ref : undefined,
    loading: request.loading,
    options: options
  }, props, {
    placeholder: request.loading ? loadingMessage : props.placeholder
  }));
});
Graph.defaultProps = {
  queryKey: 'dropdown',
  labelKey: 'label',
  valueKey: 'value',
  fetchPolicy: 'no-cache'
};
export default Graph;